export var textColor = {
  normal: '#222222',
  gray: '#666666',
  grayDark: '#999999',
  grayDarker: '#cccccc'
};
export var borderColor = {
  normal: '#dddddd',
  gray: '#eeeeee'
};
export var backgroundColor = {
  normal: '#F5F5F5',
  gray: '#F8F8F8'
};
export var colors = {
  green: '#58CC74',
  yellow: '#FBD449',
  orange: '#F2A649',
  red: '#F4647C',
  violet: '#9760E6',
  lightPurple: '#5155D0',
  bluePurple: '#445189',
  blue: '#409EFF',
  bluishGreen: '#4CCCCB'
};
export default [colors.green, colors.blue, colors.bluishGreen, colors.yellow, colors.orange, colors.red, colors.violet, colors.lightPurple, colors.bluePurple];